<template>
  <svg
    width="1875"
    height="1055"
    viewBox="0 0 1875 1055"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1521_20420)">
      <g clip-path="url(#clip1_1521_20420)">
        <path
          d="M144.724 431.114L149.521 438.577"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M149.521 449.093L146.506 450.357"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M146.506 450.357L134.137 431.114"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M144.595 430.913L144.723 431.113"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M134.137 431.113L134.009 430.913"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M134.009 430.913L133.236 429.712L141.577 426.217L144.595 430.913"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M434.854 431.114L434.863 431.468L428.523 434.162L427.829 433.099L417.049 437.683"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M417.048 437.683L412.764 431.114"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M150.769 440.521L154.844 446.862L150.769 448.571"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M383.412 431.114L382.993 431.293L393.604 447.563L392.457 448.052L396.191 453.774L392.741 455.239L394.38 457.751L381.235 463.339"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M381.235 463.339L360.24 431.149L360.324 431.114"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M471.97 431.114L498.894 468.84L493.005 471.578"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M493.005 471.578L464.126 431.114"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M507.525 499.729L495.176 483.005L502.419 479.516L514.769 496.241L507.525 499.729V499.729Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M540.074 549.07L516.039 511.877L528.572 506.596L552.606 543.789L540.074 549.07Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M560.671 558.289L556.584 551.99L573.1 545.006L577.187 551.305L560.671 558.289V558.289Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M271.352 623.101L189.361 495.221L202.672 489.654L204.545 492.574L209.709 490.415L245.44 546.148L240.277 548.304L246.676 558.285L251.839 556.129L287.574 611.859L282.407 614.017L284.666 617.538L271.352 623.101V623.101Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M591.636 636.689L575.599 613.197L589.062 607.205L605.1 630.694L591.636 636.689V636.689Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M294.514 647.643L279.562 623.482L284.018 621.683L298.974 645.847L294.514 647.643H294.514Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M580.679 685.77L571.846 683.358L575.008 675.807L583.839 678.22L580.679 685.77Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M597.432 689.789L582.101 685.9L592.156 660.063L607.487 663.952L597.432 689.789V689.789Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M336.541 706.703L315.615 673.777L319.572 672.138L340.501 705.061L336.541 706.703V706.703Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M340.16 712.314L337.188 707.798L340.688 706.3L343.656 710.814L340.16 712.314H340.16Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M343.831 718.151L340.594 713.217L343.84 711.828L347.074 716.762L343.831 718.152V718.151H343.831Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M347.512 723.9L344.279 718.966L347.522 717.58L350.758 722.515L347.512 723.9V723.9Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M350.959 729.383L348.035 724.834L351.359 723.441L354.284 727.992L350.959 729.383H350.959Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M403.525 807.574L399.832 802.991L392.61 793.435L383.412 780.049L353.167 732.824L356.422 731.466L386.643 778.651L395.779 791.945L402.935 801.413L406.596 805.96L403.525 807.574H403.525Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M451.713 882.073L429.69 865.649L431.707 863.883L429.174 861.997L433.646 858.102L458.194 876.406L451.713 882.073V882.073Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M473.736 899.314L457.496 886.592L464.088 881.104L480.33 893.826L473.736 899.314Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1087.76 965.372L1085.96 966.712"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1085.96 966.712L1079.71 961.236L1087.76 955.245"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1058.32 987.263L1051.88 981.469L1073.79 965.61L1080.22 971.409L1058.32 987.263V987.263Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M531.877 677.139L530.182 676.775L528.824 675.477L385.342 465.919L399.265 459.701L542.751 669.263L535.097 672.677L535.992 674.275L535.539 675.859L533.928 676.86L531.877 677.139V677.139Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M149.521 438.576L150.768 440.52"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M150.768 448.572L149.521 449.094"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M360.325 431.113L360.798 430.913"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M383.885 430.913L383.412 431.113"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M434.847 430.913L434.853 431.113"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M412.764 431.113L412.633 430.913"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M471.826 430.913L471.97 431.113"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M464.126 431.113L463.982 430.913"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M349.564 405.807L344.091 399.477L349.083 396.661L354.563 402.99L349.564 405.807V405.807Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M360.798 430.913L367.288 428.154L367.744 424.789L369.192 421.426L371.625 417.975L374.387 414.883L377.365 412.502L381.452 410.65L390.478 424.489L387.103 425.926L388.951 428.757L383.885 430.913"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M412.633 430.914L405.111 419.381L401.937 420.73L391.491 404.712L395.316 403.724L400.045 403.349L404.588 403.461L408.89 403.962L413.061 404.903L417.286 406.327L420.886 408.014L433.559 402.75L437.584 409.071L431.36 411.656L434.791 417.037L431.319 418.48L433.79 423.182L434.741 426.875L434.847 430.914"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M463.982 430.914L458.531 423.273L464.42 420.535L471.826 430.914"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1089.01 954.312L1096.53 948.717L1102.78 954.193L1089.01 964.44"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1089.01 964.44L1087.76 965.373"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1087.76 955.244L1089.01 954.312"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1463.12 533.627L1459.78 530.592L1467.09 525.376L1470.41 528.415L1463.12 533.627V533.627Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1448.72 548.733L1444.82 545.421L1451.6 540.204L1455.5 543.518L1448.72 548.733V548.733Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1360.28 645.281L1353.07 640.41L1363.08 630.754L1370.29 635.622L1360.28 645.281Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1369.2 761.978L1363.16 756.05L1380.13 744.781L1386.17 750.714L1369.2 761.978Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1452.06 580.759L1441.29 571.262L1593.47 458.783L1604.23 468.276L1452.06 580.759Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1423.47 591.826L1417.42 586.121L1424.39 581.118L1423.03 579.879L1427.25 576.854L1428.62 578.093L1433.63 574.5L1441.37 581.544L1434.38 586.557L1432.81 585.126L1423.47 591.826V591.826Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M532.959 431.114L562.122 465.142"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M359.588 431.114L381.324 464.52L383.675 468.562"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M549.885 472.608L513.825 431.114"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M571.975 476.64L582.911 489.401L659.656 577.715L712.826 638.486L716.679 642.612L720.116 645.479L723.04 647.419L727.006 649.256L730.208 650.222L734.696 650.926L739.697 651.014L743.944 650.823L748.43 650.034L752.382 648.939L755.11 647.907L757.78 646.424L760.548 644.512L805.04 607.537L810.188 602.851L814.807 597.522L818.216 592.894L821.631 586.714L823.914 581.354L825.637 575.172L826.647 568.804L827.06 563.363L826.825 557.775L826.046 552.045L824.624 546.573L822.875 541.228L820.643 536.276L817.44 530.928L813.756 526.1L809.421 521.656L803.869 516.287L706.956 431.114"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M383.674 468.562L378.352 470.688L521.562 680.106L527.711 677.25L542.563 698.683L576.362 700.867L581.753 700.663L584.684 700.156L587.796 699.058L590.819 697.594L593.481 695.983L595.592 693.848L597.215 691.508"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M524.248 708.89L525.4 708.858L526.419 708.504L526.735 707.97L526.65 707.497L525.525 705.419L519.724 697.287L345.946 443.291L345.645 442.957L345.198 442.703L344.578 442.638L344.015 442.732L343.552 442.948L343.115 443.273L342.864 443.673L342.849 444.137L342.99 444.652L523.439 708.404L524.248 708.89V708.89Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M597.405 713.303L599.02 712.542L599.474 711.753L599.242 708.409L598.532 705.345L597.975 703.518L597.175 702.148L595.89 700.902L594.679 699.995L592.577 699.704L589.24 701.321L585.651 702.586L582.16 703.19L576.308 703.409L556.668 702.141L555.577 702.135L554.366 702.36L553.616 702.87L553.266 703.891L553.375 704.914L554.063 705.611L555.53 706.128L580.853 707.776L585.334 708.265L589.34 709.062L592.98 710.486L596.214 712.282L597.405 713.303V713.303Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M601.822 691.587L601.231 697.453L601.388 703.327L602.12 706.49L603.787 708.752L606.016 710.567L609.178 712.381L613.648 714.205L644.741 724.202L646.47 723.517L639.47 665.022L639.127 659.956L639.605 655.663L640.931 651.158L643.837 646.665L647.409 642.857L651.884 639.658L657.589 636.648L667.859 631.223L669.6 630.078L670.526 629.267L671.69 627.893L672.662 626.485L673.594 624.805L674.123 623.072L674.367 620.55L674.223 618.012L673.764 615.728L672.909 613.976L647.318 584.727L559.764 483.978"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M877.672 739.72L879.079 736.526L880.531 732.133L881.828 726.76L882.378 722.016L882.404 717.073L882.247 713.177L881.475 708.615L880.487 704.867L879.088 701.309L877.5 697.786L875.604 694.757L873.074 690.974L869.19 686.009L821.781 626.793L817.794 620.908L815.904 615.992L770.884 653.404L766.984 656.099L762.633 658.514L758.046 660.248L752.495 661.788L745.98 662.93L739.954 663.202L733.086 663.083L726.102 661.991L720.566 660.317L714.436 657.479L709.871 654.45L705.191 650.545L700.638 645.667L687.074 630.169L686.361 631.668L684.528 634.319L682.358 636.875L679.965 638.974L676.775 641.07L665.845 646.844L661.059 649.368L658.529 651.177L656.628 653.204L655.178 655.452L654.536 657.629L654.255 660.169L654.504 663.874L665.485 729.605L773.34 730.646L798.612 731.203L816.887 732.204L832.045 733.509L852.446 735.931L869.065 738.043L877.672 739.72V739.72Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M727.443 431.114L815.222 508.259L821.14 513.982L826.144 519.109L830.691 525.067L834.559 531.529L837.287 537.583L839.307 543.763L840.965 550.124L841.884 556.908L842.159 563.526L841.678 569.95L840.512 577.29L838.45 584.684L835.679 591.188L831.633 598.507L830.437 600.131L830.015 602.803L829.881 605.719L829.98 609.515L830.447 612.725L831.757 616.133L834.75 620.557L881.903 679.45L886.104 684.819L888.977 689.112L891.37 692.936L893.375 697.385L895.091 701.75L896.349 706.522L897.299 712.151L897.494 716.898L897.466 722.61L896.781 728.5L895.242 734.869L893.5 740.145L892.418 742.598L895.746 742.918L899.304 742.748L902.104 742.195L904.243 741.184L906.269 739.832L908.593 737.973L911.298 734.927"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M639.483 743.597L641.764 743.215L645.847 741.225L646.817 740.281L647.308 738.835L647.53 735.994L647.161 729.352L611.58 717.911L606.203 716.526L603.486 716.075L601.941 716.363L600.906 716.92L601.481 717.659L602.808 720.302L603.671 723.256L603.892 727.164L603.974 729.623L604.2 730.65L604.606 731.664L605.24 732.452L605.879 732.997L606.798 733.603L608.25 734.27L636.424 743.55L639.483 743.597V743.597Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M590.195 787.592L595.052 787.273L599.328 786.612L603.043 785.458L605.908 784.284L608.55 782.51L612.356 779.632L617.248 774.343L623.128 768.718L641.098 750.022L605.776 738.387L602.386 736.835L600.296 735.472L598.943 733.777L598.111 731.997L597.701 730.135L597.61 727.344L597.419 723.962L596.8 721.844L595.868 719.978L594.408 718.114L592.112 716.161L589.81 714.884L587.196 713.861L584.159 713.257L580.178 712.822L545.801 710.585L540.249 709.928L536.549 709.168L535.302 709.18L534.632 709.629L534.294 710.389L534.395 711.074L565.391 775.999L566.677 777.88L568.722 780.271L571.086 782.261L573.85 783.915L577.947 785.7L581.819 786.851L585.613 787.42L590.195 787.592V787.592Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M810.701 817.411L812.767 812.802L816.361 807.78L821.028 802.61L871.739 748.962L875.473 743.987L876.22 742.569L868.327 741.03L851.879 738.94L831.57 736.531L816.558 735.238L798.434 734.243L773.265 733.69L665.995 732.654L669.56 754.003L781.28 789.667L786.349 791.413L791.616 793.913L795.62 796.807L798.669 799.725L801.827 803.299L810.701 817.411V817.411Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M842.837 821.962L843.569 821.743L888.977 772.49L890.754 768.783L891.658 765.915L891.824 762.449L891.257 757.309L890.238 753.958L888.777 749.768L884.223 755.834L847.526 794.656L842.153 820.72L841.978 821.649L842.266 821.921L842.837 821.962V821.962Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M839.141 847.803L837.255 844.298L836.252 840.493L835.779 837.803L835.795 834.69L836.255 831.705L838.428 820.24L842.634 799.83L833.121 809.896L829.024 814.433L826.5 817.962L824.915 821.498L823.801 825.159L823.153 828.948L823.138 832.486L823.901 836.408L825.684 841.241L831.605 850.653"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M842.316 852.544L839.142 847.804"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M831.604 850.654L834.747 855.342"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M834.748 855.34L834.81 855.434"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M817.696 855.444L788.887 809.633L786.744 807.205L784.767 805.315L782.673 803.798L779.876 802.467L775.839 801.272L657.682 774.26L652.804 773.941L647.921 774.379L643.787 775.274L639.65 776.926L635.884 779.339L631.531 783.503L625.995 789.488L620.616 793.554L615.988 796.66L610.467 798.925L604.356 800.825L597.503 801.882L590.508 802.339L583.515 802.076L576.969 801.094L570.432 799.151L564.047 796.369L559.001 793.349L554.554 789.611L551.155 785.638L308.944 431.114"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M820.868 860.217L817.696 855.442"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M820.93 860.312L820.868 860.218"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M834.81 855.435L854.022 884.064"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M854.022 884.064L854.085 884.158"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M840.023 889.057L820.93 860.312"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M840.086 889.152L840.023 889.058"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M854.085 884.159L858.235 890.348"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M858.234 890.347L858.297 890.44"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M844.356 895.578L840.087 889.151"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M858.298 890.441L864.299 899.381"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M864.299 899.379L864.362 899.473"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M864.361 899.474L864.927 900.319"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M850.338 904.588L844.355 895.58"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M850.401 904.681L850.338 904.587"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M850.964 905.528L850.401 904.68"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M864.927 900.32L874.966 911.452L880.061 917.294L912.45 963.565L914.266 965.724L916.127 967.436L918.098 968.787L921.29 970.22L924.527 971.375L927.518 972.001L930.91 972.276L934.25 972.232L937.7 971.782L941.819 970.724L945.619 969.1L951.033 965.814L1087.76 865.084"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1087.76 881.573L960.672 975.2L953.731 979.418L947.676 982.004L941.212 983.661L935.583 984.4L930.269 984.465L924.856 984.027L919.551 982.917L914.56 981.137L909.468 978.849L905.525 976.149L902.31 973.195L899.621 969.994L867.292 923.814L862.701 918.545L850.963 905.528"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M359.459 430.913L359.587 431.113"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M513.826 431.113L513.65 430.913"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M532.786 430.913L532.959 431.113"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M308.944 431.113L308.81 430.913"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M706.956 431.113L706.727 430.913"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M727.216 430.913L727.444 431.113"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M562.122 465.142L563.817 467.121"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M551.595 474.577L549.885 472.606"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M563.817 467.122L570.369 474.765"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M570.369 474.768L571.974 476.642"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M558.151 482.117L551.596 474.579"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M559.764 483.978L558.151 482.116"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M562.938 76.5816L564.43 76.4814"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M548.409 77.5551L562.939 76.582"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M535.423 78.4255L548.409 77.5557"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M483.417 81.9075L535.423 78.4248"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M475.028 82.4683L483.417 81.9082"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M575.696 87.9502L574.204 88.0503"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M574.204 88.0498L559.677 89.0229"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M559.677 89.0225L546.958 89.8767"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M546.958 89.8779L494.851 93.3667"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M494.851 93.3662L486.406 93.9325"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M564.431 76.4829L652.144 70.6067L668.566 70.2812L681.18 70.8696L693.79 72.1148L706.666 74.5648L719.266 77.7814L732.27 81.8741L743.778 86.2921L755.316 91.7677L766.941 98.2071L777.725 105.322L787.661 113.113L796.874 121.483L804.636 129.925L811.561 139.121L926.521 296.895L950.921 329.812L959.568 341.598L965.216 347.268L971.815 352.481L979.174 356.933L987.484 360.629L996.557 363.1L1005.26 364.656L1014.15 365.604L1023.42 365.481L1032.9 364.442L1042.26 362.112L1077.73 348.557L1086.63 345.606L1087.76 345.341"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1087.76 358.397L1083.83 359.702L1047.74 373.495L1036.16 376.38L1024.56 377.65L1013.28 377.797L1002.63 376.664L992.5 374.852L981.385 371.82L970.974 367.196L961.973 361.748L954.023 355.468L947.136 348.557L937.957 336.041L913.544 303.108L798.612 145.372L792.104 136.733L785.152 129.173L776.751 121.539L767.676 114.423L757.883 107.962L747.213 102.055L736.701 97.061L726.283 93.0621L714.245 89.2761L702.655 86.3161L691.133 84.1259L679.824 83.0058L668.315 82.4707L652.954 82.7773L575.695 87.9495"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M486.406 93.9326L413.58 98.8106L408.611 99.4646L405.291 100.485L401.754 102.071L398.289 104.196L395.122 106.586L392.695 108.892L391.04 111.301L389.342 114.653L388.356 118.257L387.966 121.802L388.047 125.45L388.488 129.24L389.401 131.768L391.556 135.301L394.427 138.386L398.605 142.146L583.264 304.401L673.813 383.98"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M662.98 392.468L572.152 312.643L387.434 150.335L382.759 146.126L378.643 141.708L375.281 136.195L373.602 131.533L372.973 126.132L372.863 121.37L373.414 116.398L374.884 111.007L377.414 106.023L380.226 101.927L384.182 98.1657L388.551 94.8708L393.489 91.8421L398.915 89.4109L404.67 87.6398L411.738 86.7105L475.029 82.4678"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M336.504 404.596L340.053 408.695L345.048 412.303L351.122 416.455L355.619 419.603L358.368 420.82L362.753 429.221L359.318 430.701L359.46 430.914"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M513.65 430.913L318.01 205.799L313.022 200.435L309.8 197.678L306.492 195.457L302.436 193.232L298.048 191.48L293.769 190.254L289.022 189.117L284.193 188.452L279.001 188.142L274.172 188.007L269.196 188.345L264.143 189.212L259.964 190.438L227.06 205.219L222.278 208.041L218.478 210.788L215.038 213.833L212.267 217.072L210.04 220.258L208.045 223.63L206.747 227.1L205.536 231.117L204.999 235.226L204.914 239.3L205.217 243.502L205.934 247.31L207.053 250.727L208.908 254.212L255.936 323.043L284.828 358.672L317.234 399.03L318.554 400.657L321.779 403.758L325.576 406.708L330.051 409.661L350.654 423.132L351.671 423.27L352.235 423.151L352.359 422.472L346.11 418.073L339.744 412.893L336.503 410.059L333.306 406.214"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M308.809 430.914L192.511 260.687L189.774 255.542L188.054 250.304L187.069 245.035L186.675 239.607L186.784 234.332L187.532 228.593L189.149 223.23L190.994 218.298L193.859 213.458L196.798 209.256L200.736 204.65L205.624 200.323L210.788 196.59L217.208 192.8L252.371 177.006L259.104 175.028L266.523 173.755L273.719 173.267L279.989 173.439L286.41 173.824L293.159 174.756L299.412 176.252L305.165 177.897L311.646 180.491L317.466 183.68L322.301 186.928L326.989 190.933L332.766 197.153L348.247 215.038L402.686 278.437L489.624 380.55L532.786 430.914"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M706.727 430.915L672.673 400.986"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M683.443 392.443L727.216 430.913"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M673.813 383.979L675.428 385.397"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M675.428 385.397L681.924 391.108"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M681.924 391.108L683.444 392.445"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M664.61 393.9L662.98 392.469"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M671.047 399.555L664.61 393.898"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M672.673 400.985L671.047 399.556"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1211.79 431.118L1202.91 617.203L1202.89 622.989L1203.19 626.647L1203.97 629.534L1205.46 632.429L1207.93 635.683L1210.92 638.605L1214.22 641.209L1217.92 643.08L1222.32 644.795L1226.43 645.783L1231.44 646.284L1236.16 646.303L1240.57 646.074L1244.69 645.279L1249 643.42L1316.27 598.09"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1316.18 614.012L1257.47 653.58L1250.08 656.763L1242.83 658.164L1236.61 658.483L1230.48 658.462L1223.33 657.745L1216.87 656.193L1210.61 653.762L1204.83 650.833L1199.8 646.869L1195.61 642.776L1191.99 637.983L1189.52 633.211L1188.21 628.355L1187.8 623.373L1187.82 616.953L1196.7 431.118"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1089.01 864.162L1315.75 697.125"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1315.66 713.676L1089.01 880.649"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1087.76 865.083L1089.01 864.16"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1089.01 880.652L1087.76 881.575"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1196.7 431.116L1196.71 430.913"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1211.81 430.913L1211.79 431.116"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1196.71 430.913L1197.35 417.437L1197.13 410.933L1195.5 404.236L1193.93 399.158L1192.27 394.796L1189.56 390.019L1185.73 384.417L1181.37 379.27L1174.99 373.381L1170.24 369.517L1164.84 366.088L1158.14 362.396L1151.32 359.36L1145.1 357.165L1137.96 355.424L1130.86 354.298L1122.51 353.7L1114.27 353.747L1105.46 354.364L1098.75 355.462L1091.6 357.123L1089.02 357.984"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1089.02 345.048L1095.15 343.622L1103.3 342.289L1113.57 341.566L1123.13 341.517L1132.99 342.22L1141.61 343.587L1150.32 345.712L1158 348.422L1166.06 352.008L1173.77 356.26L1180.3 360.406L1186.04 365.074L1193.32 371.795L1198.59 378.018L1203.05 384.533L1206.4 390.446L1208.48 395.888L1210.24 401.589L1212.18 409.58L1212.45 417.506L1211.81 430.913"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1087.76 345.341L1089.02 345.05"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1089.02 357.984L1087.76 358.397"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1602.83 462.912L1629.18 453.549L1630.11 452.74L1631.96 450.978L1633.58 448.403L1634.25 447.276L1635.09 445.377L1635.53 443.475L1635.71 441.506L1635.63 439.673L1635.14 437.498L1634.4 435.255L1633.72 433.691L1631.71 431.509L1631.31 431.118"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1585.65 431.118L1537.39 464.066L1584.64 434.892L1591 431.118"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1406.05 574.241L1445.41 552.518L1594.88 455.245L1602.83 462.911"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1420.16 591.83L1418.98 592.177"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1418.98 592.177L1419.61 593.579L1419.87 595.306L1419.84 598.711L1419.64 601.796L1418.25 605.059L1413.98 611.066L1396.61 626.042L1389.73 632.369L1388.55 634.981L1397.54 626.723L1414.99 611.674L1419.39 605.481L1420.89 601.992L1421.1 598.739L1421.12 595.246L1420.83 593.341L1420.16 591.83"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1316.27 598.09L1317.53 597.241L1384.55 552.074L1500.53 473.281L1562.28 431.118"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1376.62 652.298L1448.84 599.337L1559.85 517.49L1652.22 449.523L1655.99 446.497L1657.84 444.864L1659.55 442.939L1661.7 440.255L1663.77 437.358L1665.14 434.082L1665.88 431.118"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1638.41 431.118L1638.79 431.535L1639.8 433.919L1640.66 436.491L1641.28 439.181L1641.38 441.6L1641.14 444.056L1640.58 446.575L1639.47 449.042L1638.65 450.418L1636.71 453.528L1634.33 455.774L1633.15 456.807L1568.47 503.707L1429.87 605.539L1401.74 629.795L1390.07 640.505L1376.62 652.298"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1600.56 431.118L1588.02 438.547L1514.76 483.791L1475.23 506.388L1394.14 561.477L1317.44 613.164L1316.18 614.012"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1315.96 658.3L1317.21 657.161L1406.05 574.242"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1315.75 697.124L1317.01 696.195L1333.29 684.403L1360.32 659.84L1376.99 645.231L1383.92 633.394L1385.57 629.683L1384.34 629.452L1382.76 633.003L1375.93 644.659L1359.39 659.158"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1681.07 431.118L1681.05 431.982L1679.74 437.242L1677.59 442.385L1674.59 446.61L1672.02 449.804L1669.6 452.542L1666.89 454.936L1662.61 458.356L1570.02 526.486L1458.99 608.345L1364.36 677.749L1316.93 712.749L1315.66 713.679"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1600.9 430.913L1600.56 431.116"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1631.31 431.116L1631.09 430.913"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1638.22 430.913L1638.41 431.116"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1591 431.116L1591.34 430.913"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1665.88 431.116L1665.93 430.913"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1585.94 430.913L1585.65 431.116"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1681.08 430.913L1681.07 431.116"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1562.28 431.116L1562.57 430.913"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1631.1 430.915L1630.21 430.077L1628.03 428.713L1624.75 427.276L1621.72 426.313L1618.11 425.759L1615.58 425.681L1612.64 425.875L1609.86 426.409L1605.9 427.958L1600.9 430.915"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1591.34 430.916L1602.97 424.03L1607.95 422.08L1611.74 421.351L1615.46 421.106L1618.75 421.206L1623.31 421.907L1627.14 423.128L1631.13 424.878L1634.14 426.757L1636.15 428.663L1638.22 430.916"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1665.93 430.913L1665.99 430.654L1666.09 426.651L1665.65 423.87L1664.88 421.163L1663.63 418.373L1661.75 415.547L1659.69 412.956L1657.13 410.728L1654.08 408.648L1651.23 407.102L1647.85 405.685L1644.54 404.686L1639.5 403.917L1634.33 403.901L1629.8 404.555L1624.52 405.979L1617.01 409.699L1585.94 430.913"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1562.57 430.915L1608.14 399.8L1618.11 394.869L1626.06 392.723L1633.01 391.716L1640.95 391.744L1648.61 392.914L1653.98 394.531L1658.94 396.609L1663.19 398.912L1667.56 401.904L1671.66 405.464L1674.76 409.366L1677.43 413.38L1679.4 417.736L1680.51 421.744L1681.2 425.98L1681.08 430.915"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M720.659 443.159L803.868 516.287L809.421 521.656L813.755 526.1L817.44 530.927L820.643 536.275L822.874 541.228L824.624 546.572L826.046 552.045L826.824 557.774L827.059 563.362L826.646 568.803L825.635 575.171L823.914 581.354L821.63 586.713L818.216 592.894L814.806 597.521L810.188 602.85L805.039 607.537L760.548 644.512L757.78 646.424L755.108 647.908L752.382 648.94L748.43 650.034L743.944 650.823L739.696 651.013L734.695 650.925L730.207 650.221L727.006 649.255L723.04 647.419L720.116 645.48L716.679 642.612L712.824 638.486L659.655 577.715L582.911 489.4L571.973 476.64V476.641L570.369 474.765L563.816 467.122L562.122 465.142V465.141L532.959 431.114L532.785 430.914L489.624 380.55L402.686 278.437L348.247 215.038L332.765 197.153L326.989 190.933L322.302 186.928L317.466 183.68L311.646 180.492L305.166 177.898L299.412 176.253L293.16 174.757L286.41 173.825L279.988 173.44L273.718 173.268L266.522 173.756L259.103 175.029L252.371 177.007L217.208 192.8L210.788 196.59L205.624 200.323L200.736 204.65L196.799 209.256L193.859 213.458L190.994 218.298L189.149 223.229L187.532 228.593L186.784 234.332L186.675 239.606L187.069 245.035L188.054 250.304L189.774 255.542L192.511 260.687L308.809 430.914L308.943 431.114L335.574 470.095"
          stroke="#22DB4B"
          stroke-width="0.1"
          stroke-miterlimit="10"
        />
        <path
          d="M1210.78 452.394L1211.79 431.117L1211.81 430.914L1212.45 417.506L1212.18 409.581L1210.24 401.59L1208.48 395.888L1206.4 390.447L1203.05 384.533L1198.59 378.019L1193.32 371.796L1186.04 365.075L1180.3 360.406L1173.77 356.26L1166.06 352.008L1158 348.423L1150.32 345.713L1141.61 343.588L1132.99 342.22L1123.12 341.517L1113.57 341.567L1103.3 342.29L1095.15 343.623L1089.02 345.049V345.05L1087.76 345.341L1086.63 345.606L1077.73 348.557L1042.25 362.112L1032.89 364.442L1023.42 365.481L1014.15 365.604L1005.26 364.656L996.556 363.1L987.483 360.629L979.174 356.933L971.814 352.481L965.216 347.268L959.567 341.598L950.921 329.812L926.519 296.895L811.56 139.121L804.635 129.925L796.873 121.483L787.66 113.114L777.723 105.322L766.94 98.2072L755.315 91.7678L743.778 86.2921L732.269 81.8741L719.265 77.7814L706.665 74.5648L693.788 72.1148L681.179 70.8696L668.566 70.2812L652.143 70.6067L564.431 76.4825L562.939 76.5829L548.408 77.5556L535.422 78.4259L483.416 81.9085L475.028 82.4682L411.737 86.7111L404.67 87.6404L398.915 89.4115L393.489 91.8426L388.551 94.8714L384.182 98.1662L380.226 101.927L377.413 106.023L374.883 111.007L373.413 116.399L372.863 121.37L372.972 126.133L373.601 131.533L375.28 136.195L378.643 141.709L382.759 146.127L387.434 150.335L572.152 312.643L662.98 392.469L664.61 393.899L671.047 399.556L672.672 400.985L706.726 430.914L706.955 431.114L720.659 443.158"
          stroke="#FD6A6A"
          stroke-width="0.1"
          stroke-miterlimit="10"
        />
        <path
          d="M1140.85 842.462L1315.66 713.676V713.677L1316.93 712.748L1364.36 677.748L1459 608.344L1570.02 526.485L1662.61 458.355L1666.89 454.935L1669.6 452.541L1672.02 449.803L1674.59 446.609L1677.59 442.384L1679.74 437.241L1681.05 431.981L1681.07 431.117L1681.08 430.914L1681.2 425.979L1680.51 421.743L1679.4 417.735L1677.43 413.379L1674.76 409.365L1671.66 405.463L1667.56 401.903L1663.19 398.911L1658.94 396.608L1653.98 394.53L1648.61 392.913L1640.95 391.743L1633.01 391.715L1626.06 392.722L1618.11 394.868L1608.14 399.799L1562.57 430.914L1562.28 431.117L1500.53 473.28L1384.55 552.073L1317.53 597.24L1316.27 598.089L1249 643.419L1244.69 645.278L1240.57 646.073L1236.16 646.302L1231.44 646.283L1226.43 645.782L1222.32 644.794L1217.92 643.079L1214.22 641.208L1210.92 638.604L1207.93 635.682L1205.47 632.428L1203.97 629.533L1203.19 626.646L1202.89 622.988L1202.91 617.202L1210.78 452.394"
          stroke="#64E3FF"
          stroke-width="0.1"
          stroke-miterlimit="10"
        />
        <path
          d="M335.574 470.094L551.155 785.637L554.553 789.61L559 793.349L564.045 796.369L570.431 799.15L576.969 801.093L583.515 802.076L590.508 802.339L597.503 801.882L604.356 800.825L610.466 798.925L615.986 796.66L620.614 793.553L625.993 789.488L631.531 783.502L635.883 779.338L639.648 776.926L643.787 775.274L647.921 774.379L652.804 773.941L657.681 774.26L775.839 801.272L779.875 802.467L782.673 803.797L784.767 805.315L786.743 807.205L788.887 809.633L817.696 855.444L850.962 905.528L862.7 918.545L867.291 923.814L899.621 969.994L902.311 973.195L905.525 976.149L909.468 978.849L914.56 981.137L919.551 982.917L924.856 984.027L930.27 984.465L935.583 984.4L941.213 983.661L947.677 982.004L953.732 979.418L960.672 975.2L1087.76 881.573L1089.01 880.65L1140.85 842.462"
          stroke="#FFF38A"
          stroke-width="0.1"
        />
        <path
          d="M641.097 750.022L623.127 768.718L617.248 774.343L612.356 779.632L608.549 782.51L605.907 784.284L603.042 785.458L599.327 786.612L595.051 787.273L590.193 787.591L585.611 787.42L581.818 786.85L577.947 785.699L573.849 783.915L571.085 782.261L568.721 780.271L566.676 777.88L565.391 775.999L523.439 708.404L353.621 460.192"
          stroke="#FFF38A"
          stroke-width="0.1"
        />
        <path
          d="M356.452 458.647L519.724 697.287L525.525 705.419L526.651 707.497L526.735 707.97L536.549 709.168L540.248 709.928L545.8 710.585L580.178 712.822L584.159 713.257L587.195 713.861L589.81 714.884L592.112 716.161L594.407 718.114L595.868 719.978L596.799 721.844L597.419 723.962L597.701 730.135L598.11 731.997L598.942 733.777L600.296 735.473L602.386 736.835L605.776 738.387L641.097 750.022"
          stroke="#FFF38A"
          stroke-width="0.1"
        />
        <path
          d="M353.621 460.193L342.989 444.652L342.848 444.137L342.864 443.673L343.115 443.273L343.551 442.948L344.015 442.732L344.577 442.638L345.198 442.703L345.645 442.957L345.946 443.291L356.452 458.647"
          stroke="#22DB4B"
          stroke-width="0.1"
          stroke-miterlimit="10"
        />
        <path
          d="M371.979 450.158L381.323 464.518L383.675 468.561L378.351 470.688L521.561 680.105L527.71 677.249L542.562 698.682L554.063 705.611L555.53 706.128L580.853 707.776L585.334 708.265L589.34 709.062L592.981 710.486L596.214 712.282L597.405 713.303L600.906 716.919L601.481 717.658L602.808 720.301L603.671 723.255L603.974 729.622L604.2 730.649L604.606 731.663L605.24 732.451L605.879 732.996L606.798 733.602L608.25 734.269L636.424 743.549L639.483 743.596L669.56 754.002L781.279 789.666L786.348 791.412L791.615 793.912L795.62 796.806L798.669 799.725L801.827 803.298L810.701 817.41L825.683 841.24L831.604 850.652L834.748 855.34L834.809 855.434L854.022 884.063L854.085 884.158L858.234 890.346L858.298 890.441L864.297 899.38L864.36 899.473L864.926 900.319L874.966 911.451L880.061 917.293L912.45 963.564L914.265 965.723L916.127 967.435L918.098 968.786L921.29 970.219L924.528 971.374L927.518 972L930.91 972.275L934.251 972.231L937.699 971.781L941.82 970.723L945.619 969.099L951.033 965.813L1087.76 865.083L1089.01 864.16L1132.43 832.176"
          stroke="#FFF38A"
          stroke-width="0.1"
        />
        <path
          d="M1195.71 451.676L1187.82 616.951L1187.8 623.372L1188.21 628.353L1189.52 633.209L1191.99 637.981L1195.61 642.774L1199.8 646.867L1204.83 650.832L1210.61 653.761L1216.87 656.192L1223.33 657.744L1230.48 658.46L1236.61 658.482L1242.83 658.163L1250.08 656.761L1257.47 653.579L1316.18 614.01L1317.44 613.162L1394.14 561.475L1475.23 506.387L1480.79 502.599L1537.39 464.065L1585.65 431.117L1585.94 430.913L1617.01 409.699L1624.52 405.979L1629.8 404.555L1634.33 403.901L1639.5 403.917L1644.54 404.686L1647.85 405.685L1651.23 407.102L1654.08 408.648L1657.13 410.728L1659.68 412.956L1661.75 415.547L1663.62 418.373L1664.88 421.163L1665.65 423.87L1666.09 426.651L1665.99 430.654L1665.93 430.913L1665.88 431.117L1665.14 434.08L1663.77 437.356L1661.71 440.253L1659.55 442.937L1657.84 444.862L1655.99 446.495L1652.22 449.522L1559.85 517.488L1448.84 599.336L1376.62 652.296L1333.29 684.402L1317.01 696.195L1315.75 697.124L1132.43 832.177"
          stroke="#64E3FF"
          stroke-width="0.1"
          stroke-miterlimit="10"
        />
        <path
          d="M730.269 433.597L727.442 431.113L727.215 430.913L683.443 392.443L681.923 391.107L675.427 385.396L673.813 383.979L583.264 304.401L398.604 142.147L394.427 138.386L391.556 135.301L389.401 131.768L388.488 129.24L388.047 125.451L387.966 121.802L388.355 118.257L389.341 114.653L391.04 111.302L392.695 108.892L395.122 106.586L398.289 104.196L401.753 102.071L405.29 100.485L408.609 99.4647L413.58 98.8107L486.406 93.9326L494.849 93.3669L546.956 89.8778L559.675 89.0234L574.203 88.0505L575.694 87.9503L652.954 82.7783L668.315 82.4717L679.824 83.0068L691.133 84.1269L702.654 86.3171L714.245 89.2771L726.283 93.0631L736.7 97.0619L747.213 102.056L757.883 107.963L767.676 114.424L776.751 121.54L785.152 129.174L792.103 136.734L798.612 145.373L913.543 303.108L937.956 336.041L947.136 348.557L954.022 355.468L961.972 361.748L970.973 367.196L981.384 371.82L992.5 374.852L1002.63 376.664L1013.28 377.797L1024.56 377.65L1036.16 376.38L1047.74 373.495L1083.83 359.702L1087.76 358.397L1089.02 357.985L1091.6 357.123L1098.75 355.462L1105.45 354.364L1114.27 353.747L1122.51 353.7L1130.86 354.298L1137.96 355.424L1145.1 357.165L1151.32 359.36L1158.14 362.396L1164.84 366.088L1170.24 369.517L1174.99 373.381L1181.37 379.27L1185.73 384.417L1189.56 390.019L1192.27 394.796L1193.93 399.158L1195.5 404.236L1197.13 410.933L1197.35 417.437L1196.71 430.913L1196.7 431.117L1195.71 451.677"
          stroke="#FD6A6A"
          stroke-width="0.1"
          stroke-miterlimit="10"
        />
        <path
          d="M371.979 450.159L359.587 431.113L359.459 430.913L351.671 423.27L350.654 423.132L330.051 409.661L325.576 406.708L321.778 403.758L318.553 400.657L317.235 399.03L284.828 358.672L255.937 323.043L208.908 254.212L207.053 250.727L205.934 247.31L205.218 243.502L204.914 239.3L204.999 235.226L205.537 231.117L206.747 227.1L208.045 223.63L210.04 220.258L212.267 217.072L215.038 213.833L218.478 210.788L222.278 208.041L227.06 205.219L259.964 190.438L264.143 189.212L269.196 188.345L274.172 188.007L279.001 188.142L284.193 188.452L289.021 189.117L293.769 190.254L298.047 191.48L302.436 193.232L306.492 195.457L309.8 197.678L313.022 200.435L318.01 205.799L513.65 430.913L513.825 431.113L549.885 472.607L551.595 474.577L558.151 482.115L559.764 483.977L647.318 584.726L672.908 613.975L687.074 630.168L700.638 645.666L705.191 650.544L709.871 654.449L714.436 657.478L720.565 660.316L726.102 661.99L733.086 663.082L739.952 663.201L745.98 662.929L752.495 661.787L758.046 660.247L762.633 658.513L766.984 656.098L770.884 653.403L815.904 615.991L830.437 600.13L831.633 598.506L835.679 591.187L838.45 584.683L840.511 577.289L841.677 569.949L842.159 563.525L841.884 556.907L840.965 550.123L839.307 543.762L837.287 537.582L834.559 531.528L830.69 525.066L826.144 519.109L821.14 513.981L815.222 508.258L730.269 433.597"
          stroke="#22DB4B"
          stroke-width="0.1"
          stroke-miterlimit="10"
        />
        <path
          d="M641.097 750.022L623.127 768.718L617.248 774.343L612.356 779.632L608.549 782.51L605.907 784.284L603.042 785.458L599.327 786.612L595.051 787.273L590.193 787.591L585.611 787.42L581.818 786.85L577.947 785.699L573.849 783.915L571.085 782.261L568.721 780.271L566.676 777.88L565.391 775.999L523.439 708.404L353.621 460.192"
          stroke="#FFF38A"
          stroke-width="0.1"
        />
        <path
          d="M356.452 458.647L519.724 697.287L525.525 705.419L526.651 707.497L526.735 707.97L536.549 709.168L540.248 709.928L545.8 710.585L580.178 712.822L584.159 713.257L587.195 713.861L589.81 714.884L592.112 716.161L594.407 718.114L595.868 719.978L596.799 721.844L597.419 723.962L597.701 730.135L598.11 731.997L598.942 733.777L600.296 735.473L602.386 736.835L605.776 738.387L641.097 750.022"
          stroke="#FFF38A"
          stroke-width="0.1"
        />
        <path
          d="M608.55 782.51L612.356 779.632L615.617 776.106L612.356 779.632L608.55 782.51Z"
          fill="white"
          fill-opacity="0.2"
        />
        <path
          d="M629.117 762.487L641.097 750.023L629.117 762.487Z"
          fill="white"
          fill-opacity="0.2"
        />
        <path
          d="M595.051 787.274L590.193 787.593L595.051 787.274L599.327 786.613L603.043 785.459L599.327 786.613L595.051 787.274Z"
          fill="white"
          fill-opacity="0.2"
        />
        <path
          d="M577.947 785.7L575.897 784.808L577.947 785.7L581.818 786.851L583.715 787.136L581.818 786.851L577.947 785.7Z"
          fill="white"
          fill-opacity="0.2"
        />
        <path
          d="M1680.51 421.743L1679.4 417.735L1677.43 413.379L1674.76 409.365L1671.66 405.463L1667.56 401.903L1663.19 398.911L1658.94 396.608L1653.98 394.53L1648.61 392.913L1640.95 391.743L1633.01 391.715L1626.05 392.722L1618.11 394.868L1608.14 399.799L1562.57 430.914L1562.28 431.117L1500.53 473.28L1384.55 552.073L1317.53 597.24L1316.27 598.089L1249 643.419L1244.69 645.278L1240.57 646.073L1236.16 646.302L1231.44 646.283L1226.43 645.782L1222.32 644.794L1217.92 643.079L1214.22 641.208L1210.92 638.604L1207.93 635.682L1205.47 632.428L1203.97 629.533L1203.19 626.646L1202.89 622.988L1202.91 617.202L1211.79 431.117L1211.81 430.914L1212.45 417.506L1212.18 409.581L1210.24 401.59L1208.48 395.888L1206.4 390.447L1203.05 384.533L1198.59 378.019L1193.32 371.796L1186.04 365.075L1180.3 360.406L1173.77 356.26L1166.06 352.008L1158 348.423L1150.32 345.713L1141.61 343.588L1132.99 342.22L1123.12 341.517L1113.57 341.566L1103.3 342.29L1095.15 343.623L1089.02 345.049V345.05L1087.76 345.341L1086.63 345.606L1077.73 348.557L1042.25 362.112L1032.89 364.442L1023.42 365.481L1014.15 365.604L1005.26 364.656L996.556 363.1L987.483 360.629L979.174 356.933L971.814 352.481L965.216 347.268L959.567 341.598L950.921 329.812L926.519 296.895L811.56 139.121L804.635 129.925L796.873 121.483L787.66 113.114L777.724 105.322L766.94 98.2072L755.315 91.7678L743.778 86.2921L732.269 81.874L719.265 77.7814L706.665 74.5648L693.788 72.1148L681.179 70.8696L668.566 70.2812L652.143 70.6067L564.43 76.4825L562.939 76.5829L548.408 77.5556L535.422 78.4259L483.416 81.9085L475.028 82.4682L411.737 86.7112L404.67 87.6404L398.915 89.4116L393.489 91.8427L388.551 94.8714L384.182 98.1662L380.226 101.927L377.413 106.023L374.883 111.007L373.413 116.399L372.863 121.37L372.972 126.133L373.601 131.533L375.28 136.195L378.643 141.709L382.759 146.127L387.434 150.335L572.152 312.643L662.98 392.468L664.61 393.899L671.047 399.556L672.672 400.985L706.726 430.914L706.955 431.114L803.869 516.287L809.421 521.656L813.755 526.1L817.44 530.928L820.643 536.275L822.874 541.228L824.624 546.572L826.046 552.045L826.825 557.774L827.059 563.363L826.646 568.804L825.636 575.171L823.914 581.353L821.631 586.714L818.216 592.893L814.806 597.521L810.188 602.85L805.039 607.537L760.548 644.512L757.78 646.423L755.109 647.907L752.382 648.939L748.43 650.034L743.944 650.822L739.696 651.013L734.695 650.925L730.207 650.221L727.006 649.256L723.04 647.418L720.116 645.479L716.679 642.612L712.824 638.486L659.656 577.715L582.911 489.401L571.974 476.64V476.641L570.37 474.765L563.816 467.122L562.122 465.142V465.141L532.959 431.114L532.785 430.914L489.624 380.55L402.686 278.437L348.247 215.038L332.766 197.153L326.989 190.933L322.302 186.928L317.466 183.68L311.646 180.492L305.166 177.898L299.412 176.252L293.16 174.757L286.41 173.824L279.989 173.439L273.718 173.267L266.522 173.755L259.104 175.029L252.371 177.006L217.208 192.8L210.788 196.591L205.624 200.323L200.736 204.65L196.799 209.256L193.859 213.458L190.994 218.298L189.149 223.23L187.532 228.593L186.784 234.332L186.675 239.607L187.069 245.035L188.054 250.304L189.774 255.542L192.511 260.687L308.81 430.914L308.943 431.114L551.155 785.637L554.553 789.61L559 793.349L564.045 796.369L570.431 799.15L576.969 801.093L583.515 802.076L590.508 802.339L597.503 801.882L604.356 800.825L610.466 798.925L615.986 796.66L620.614 793.553L625.993 789.488L631.53 783.502L635.882 779.338L639.648 776.926L643.787 775.274L647.921 774.379L652.804 773.941L657.681 774.26L775.839 801.272L779.875 802.467L782.672 803.797L784.767 805.315L786.743 807.205L788.886 809.633L817.696 855.444L850.962 905.528L862.7 918.545L867.291 923.814L899.621 969.994L902.311 973.194L905.525 976.149L909.468 978.849L914.56 981.136L919.551 982.917L924.856 984.027L930.27 984.465L935.583 984.4L941.213 983.661L947.677 982.003L953.732 979.418L960.672 975.2L1087.76 881.573L1089.01 880.65L1315.66 713.676V713.677L1316.93 712.748L1364.36 677.748L1458.99 608.344L1570.02 526.485L1662.61 458.355L1666.89 454.935L1669.6 452.541L1672.02 449.803L1674.59 446.609L1677.59 442.384L1679.74 437.241L1681.05 431.981L1681.07 431.117L1681.08 430.914L1681.2 425.979L1680.51 421.743V421.743ZM629.117 762.487L623.128 768.719L617.248 774.344L615.617 776.107L612.356 779.632L608.55 782.511L605.907 784.285L603.043 785.459L599.327 786.613L595.052 787.273L590.194 787.592L585.612 787.42L583.715 787.136L581.819 786.851L577.947 785.7L575.898 784.808L573.849 783.915L572.467 783.088L571.086 782.261L568.722 780.271L566.677 777.88L565.391 775.999L523.439 708.405L342.989 444.653L342.848 444.137L342.865 443.674L343.115 443.274L343.552 442.948L344.015 442.733L344.578 442.638L345.198 442.703L345.645 442.957L345.946 443.292L519.724 697.287L525.525 705.42L526.651 707.497L526.735 707.97L535.093 708.991L535.117 708.958L545.8 710.586L580.178 712.823L584.159 713.257L587.195 713.862L589.81 714.885L592.112 716.162L594.408 718.114L595.868 719.979L596.8 721.844L597.419 723.962L597.701 730.135L598.111 731.997L598.942 733.777L600.296 735.473L602.386 736.835L605.776 738.387L641.097 750.023L629.117 762.487L629.117 762.487ZM1665.99 430.654L1665.93 430.914L1665.88 431.117L1665.14 434.081L1663.77 437.357L1661.71 440.254L1659.55 442.938L1657.84 444.863L1655.99 446.496L1652.22 449.522L1559.85 517.488L1448.84 599.336L1376.62 652.297L1333.29 684.403L1317.01 696.195L1315.75 697.124L1089.01 864.161L1087.76 865.084L951.033 965.814L945.62 969.1L941.82 970.724L937.699 971.782L934.251 972.232L930.911 972.276L927.518 972.001L924.528 971.375L921.291 970.22L918.098 968.787L916.127 967.436L914.265 965.724L912.45 963.565L880.062 917.294L874.967 911.452L864.926 900.32L864.36 899.474L864.298 899.381L858.298 890.442L858.234 890.347L854.085 884.158L854.022 884.064L834.81 855.435L834.748 855.341L831.604 850.653L825.683 841.241L810.701 817.411L801.828 803.299L798.669 799.725L795.62 796.807L791.615 793.913L786.349 791.413L781.28 789.666L669.56 754.003L639.483 743.597L636.425 743.55L608.25 734.27L606.799 733.603L605.879 732.997L605.241 732.452L604.607 731.664L604.2 730.65L603.975 729.623L603.672 723.256L602.808 720.302L601.481 717.659L600.907 716.92L597.406 713.303L596.215 712.283L592.981 710.487L589.341 709.063L585.335 708.266L580.853 707.777L555.53 706.129L554.063 705.612L542.562 698.683L542.22 698.164L542.211 698.176L527.71 677.25L521.561 680.106L378.351 470.689L383.675 468.562L381.324 464.519L359.587 431.114L359.46 430.914L351.672 423.271L350.655 423.132L330.051 409.662L325.576 406.708L321.779 403.758L318.554 400.658L317.235 399.03L284.829 358.672L255.937 323.043L208.908 254.213L207.054 250.728L205.934 247.31L205.218 243.502L204.914 239.3L204.999 235.227L205.537 231.118L206.747 227.101L208.045 223.63L210.041 220.258L212.267 217.072L215.038 213.833L218.479 210.789L222.278 208.042L227.06 205.22L259.964 190.439L264.143 189.212L269.197 188.345L274.173 188.007L279.002 188.142L284.193 188.452L289.021 189.118L293.769 190.254L298.047 191.481L302.436 193.233L306.493 195.457L309.8 197.679L313.022 200.436L318.011 205.799L513.65 430.914L513.825 431.114L549.885 472.607L551.596 474.578L558.151 482.116L559.764 483.978L647.318 584.727L672.909 613.976L687.075 630.169L700.639 645.666L705.191 650.545L709.871 654.449L714.436 657.478L720.565 660.316L726.102 661.991L733.087 663.082L739.953 663.201L745.981 662.929L752.496 661.787L758.046 660.248L762.634 658.514L766.985 656.098L770.884 653.404L815.905 615.992L830.438 600.13L831.633 598.506L835.68 591.188L838.45 584.683L840.511 577.289L841.677 569.949L842.16 563.525L841.885 556.907L840.965 550.123L839.308 543.763L837.287 537.583L834.559 531.528L830.69 525.067L826.144 519.109L821.14 513.981L815.222 508.258L727.443 431.114L727.216 430.914L683.443 392.444L681.923 391.107L675.427 385.397L673.813 383.98L583.265 304.401L398.604 142.147L394.427 138.386L391.556 135.301L389.402 131.768L388.488 129.24L388.047 125.451L387.966 121.802L388.356 118.257L389.341 114.652L391.041 111.301L392.695 108.892L395.122 106.586L398.29 104.196L401.754 102.071L405.291 100.485L408.61 99.4646L413.58 98.8106L486.406 93.9326L494.85 93.3668L546.957 89.8777L559.676 89.0233L574.204 88.0504L575.695 87.9503L652.954 82.7782L668.315 82.4716L679.825 83.0067L691.134 84.1269L702.655 86.317L714.245 89.277L726.283 93.063L736.701 97.0619L747.213 102.056L757.883 107.963L767.676 114.424L776.751 121.54L785.152 129.174L792.103 136.734L798.613 145.373L913.543 303.109L937.956 336.041L947.136 348.557L954.022 355.468L961.972 361.748L970.973 367.196L981.384 371.821L992.5 374.853L1002.63 376.664L1013.28 377.797L1024.56 377.65L1036.16 376.38L1047.74 373.495L1083.83 359.702L1087.76 358.397L1089.02 357.985L1091.6 357.124L1098.75 355.463L1105.46 354.364L1114.27 353.748L1122.51 353.701L1130.86 354.298L1137.96 355.425L1145.1 357.165L1151.32 359.361L1158.14 362.396L1164.84 366.089L1170.24 369.517L1174.99 373.382L1181.37 379.271L1185.73 384.418L1189.56 390.019L1192.27 394.797L1193.93 399.158L1195.5 404.237L1197.13 410.933L1197.35 417.438L1196.71 430.914L1196.7 431.117L1187.82 616.952L1187.8 623.372L1188.21 628.354L1189.52 633.21L1191.99 637.982L1195.61 642.775L1199.8 646.868L1204.83 650.832L1210.61 653.761L1216.87 656.192L1223.33 657.744L1230.48 658.461L1236.61 658.482L1242.83 658.163L1250.08 656.762L1257.47 653.579L1316.18 614.011L1317.44 613.163L1394.14 561.476L1475.23 506.387L1480.79 502.6L1537.39 464.065L1585.65 431.117L1585.94 430.914L1617.01 409.7L1624.52 405.979L1629.8 404.556L1634.33 403.902L1639.5 403.918L1644.54 404.687L1647.85 405.685L1651.23 407.102L1654.08 408.649L1657.13 410.729L1659.68 412.957L1661.75 415.548L1663.62 418.373L1664.88 421.164L1665.65 423.87L1666.09 426.652L1665.99 430.654V430.654Z"
          fill="white"
          fill-opacity="0.2"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1521_20420">
        <rect width="1549" height="918" fill="white" transform="translate(133 70)" />
      </clipPath>
      <clipPath id="clip1_1521_20420">
        <rect width="1548.48" height="917.491" fill="white" transform="translate(133 70)" />
      </clipPath>
    </defs>
  </svg>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'

/**
 * レース動画再生画面: GPS詳細 サーキットマップ: Motegi
 */
export default defineComponent({
  name: 'CircuitMapImageMotegi',
})
</script>
